import { testId } from '@lojinha/helpers';
import React from 'react';
import ReactModal from 'react-modal';
import Img from 'next/image';
import styled, { createGlobalStyle } from 'styled-components';
import closeIconSrc from '../../assets/icons/close.svg';
import { t } from '../../dictionary';
import { tabNavigationStyle } from '../../helpers/tabNavigationStyle';
import { theme as DSTheme } from '../../theme';
import { Text } from '../Text';
const modalFullscreenScrollFix = `
  html, body {
    overflow: hidden;
  }
`;
const GlobalStyle = createGlobalStyle `
  ${({ isOpen }) => {
    if (!isOpen) {
        return '';
    }
    return modalFullscreenScrollFix;
}}

  .ReactModal__Body--open {
    #__next, #root {
      filter: blur(4px);
      transition: filter 0.25s;
    }
  }

  .ReactModal__Overlay {
    opacity: 0;
    transition: all 0.25s ease-in-out;
  }

  .ReactModal__Overlay--after-open {
    opacity: 1;
  }

  .ReactModal__Overlay--before-close {
    opacity: 0;
  }
`;
const Header = styled.div `
  display: flex;
  background: ${({ headerColor }) => headerColor ? headerColor : 'transparent'};
  height: ${({ theme, headerHeight }) => headerHeight ? headerHeight : theme.space.x96};
  border-bottom: 1px solid ${({ theme }) => theme.colors.gray200};
  ${({ noHeaderDivider }) => (noHeaderDivider ? 'border-bottom: none;' : '')}

  ${({ theme }) => theme.media.below('sm')} {
    height: ${({ theme, headerHeight }) => headerHeight ? headerHeight : theme.space.x64};
  }
`;
const HeaderContent = styled.div `
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: ${({ theme }) => theme.space.x20};

  ${({ theme }) => theme.media.above('sm')} {
    padding: ${({ theme }) => theme.space.x40};
  }
`;
const CloseWrapper = styled.button `
  position: absolute;
  right: ${({ theme }) => theme.space.x20};
  top: ${({ theme }) => theme.space.x20};
  gap: ${({ theme }) => theme.space.x12};
  display: flex;
  background: none;
  border: 2px solid ${({ theme }) => theme.colors.transparent};
  cursor: pointer;
  align-items: center;

  ${({ theme }) => theme.media.above('sm')} {
    right: ${({ theme }) => theme.space.x40};
    top: ${({ theme }) => theme.space.x40};
  }

  ${tabNavigationStyle}
`;
const Content = styled.div `
  text-align: center;
  padding: ${({ theme }) => theme.space.x16};
  ${({ theme }) => theme.media.above('sm')} {
    padding: ${({ theme }) => theme.space.x40};
    ${({ noPadding }) => (noPadding ? 'padding: 0;' : '')}
  }
  ${({ noHeader }) => (noHeader ? 'padding-top: 0;' : '')}
  ${({ noPadding }) => (noPadding ? 'padding: 0;' : '')}
`;
export const ModalTitle = styled.p `
  text-align: center;
  text-transform: uppercase;
  font-weight: ${({ theme }) => theme.fontWeights.bold};
  font-family: ${({ theme }) => theme.fonts.brand};
  font-size: ${({ theme }) => theme.fontSizes.x3};
  margin-bottom: ${({ theme }) => theme.space.x16};
`;
export const ModalFooter = styled.div `
  margin-top: ${({ theme }) => theme.space.x24};
`;
const customStyles = {
    content: {
        border: '0',
        borderRadius: DSTheme.borderRadius.x8,
        bottom: 'auto',
        left: '50%',
        marginRight: '-50%',
        maxWidth: '29.375rem',
        padding: '0',
        right: 'auto',
        top: '50%',
        transform: 'translate(-50%, -50%)',
        width: 'calc(100% - 2rem)',
    },
    overlay: {
        backgroundColor: 'rgba(0, 0, 0, 0.4)',
        zIndex: 10,
    },
};
const CloseButtonComponent = ({ onRequestClose, showCloseBtnText = true }) => (React.createElement(CloseWrapper, { "aria-label": t.close, onClick: onRequestClose, ...testId('close-modal') },
    showCloseBtnText && (React.createElement(Text, { isBold: true, textSize: "x1", textTransform: "uppercase" }, t.close)),
    React.createElement(Img, { src: closeIconSrc, alt: "", "aria-hidden": true, width: 20, height: 20, unoptimized: true })));
const HeaderComponent = ({ headerText, headerComponent, headerColor, headerHeight, onRequestClose, noHeaderDivider, showCloseBtnText, }) => (React.createElement(Header, { headerColor: headerColor, headerHeight: headerHeight, noHeaderDivider: noHeaderDivider },
    headerText && (React.createElement(HeaderContent, null,
        React.createElement(Text, { isBold: true }, headerText))),
    headerComponent && React.createElement(React.Fragment, null, headerComponent),
    React.createElement(CloseButtonComponent, { onRequestClose: onRequestClose, showCloseBtnText: showCloseBtnText })));
export const Modal = ({ children, isOpen, headerText, headerComponent, headerColor, headerHeight, onRequestClose, hideHeader, noPadding, noHeaderDivider, showCloseBtnText, }) => {
    return (React.createElement(React.Fragment, null,
        React.createElement(GlobalStyle, { isOpen: isOpen }),
        React.createElement(ReactModal, { isOpen: !!isOpen, onRequestClose: onRequestClose, style: customStyles, ariaHideApp: false },
            !hideHeader && (React.createElement(HeaderComponent, { headerText: headerText, headerComponent: headerComponent, headerColor: headerColor, headerHeight: headerHeight, onRequestClose: onRequestClose, noHeaderDivider: noHeaderDivider, showCloseBtnText: showCloseBtnText })),
            React.createElement(Content, { noHeader: !headerText, noPadding: noPadding }, children))));
};
//# sourceMappingURL=index.js.map